export enum RefundAllowedMode {
  No = 0,
  YesIfUsedOnOriginalOrder = 1,
  YesAlways = 2,
}
